import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RoofTypeForm, RoofTypeListMeta, RoofTypeRow } from "../types";
import { initialRoofTypeForm, initialState } from "./initialState";

export const sliceKey = "roofTypeState";

type RoofTypeListSuccessPayload = {
  data: RoofTypeRow[];
  meta: RoofTypeListMeta;
};

const roofTypeSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    getRoofTypeList(state) {
      state.loading = true;
      state.error = null;
      state.page = 1;
    },

    getRoofTypeListSuccess(
      state,
      action: PayloadAction<RoofTypeListSuccessPayload>
    ) {
      state.loading = false;
      state.list = action.payload.data;
      state.meta = action.payload.meta;
      state.page = action.payload.meta.currentPage;
      state.error = null;
    },

    getRoofTypeListError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },

    getNextPageItems(state) {
      if (state.loading || state.meta.currentPage >= state.meta.totalPages) {
        return;
      }
      state.loading = true;
      state.error = null;
      state.page = state.meta.currentPage + 1;
    },

    getNextPageItemsSuccess(
      state,
      action: PayloadAction<RoofTypeListSuccessPayload>
    ) {
      state.loading = false;
      state.list = state.list.concat(action.payload.data);
      state.meta = action.payload.meta;
      state.page = action.payload.meta.currentPage;
      state.error = null;
    },

    getNextPageItemsError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },

    openAddModal(state) {
      state.isAddModalOpen = true;
      state.error = null;
    },

    closeAddModal(state) {
      state.isAddModalOpen = false;
      state.saving = false;
      state.error = null;
      state.form = initialRoofTypeForm;
    },

    setFormField(
      state,
      action: PayloadAction<{
        name: keyof RoofTypeForm;
        value: string;
      }>
    ) {
      const { name, value } = action.payload;
      state.form[name] = value;
    },

    resetForm(state) {
      state.form = initialRoofTypeForm;
    },

    addRoofType(state) {
      state.saving = true;
      state.error = null;
    },

    addRoofTypeSuccess(state) {
      state.saving = false;
      state.isAddModalOpen = false;
      state.form = initialRoofTypeForm;
      state.error = null;
    },

    addRoofTypeError(state, action: PayloadAction<string>) {
      state.saving = false;
      state.error = action.payload;
    },
  },
});

export const { actions: roofTypeActions, reducer } = roofTypeSlice;
